import { REGION_ABBREVIATIONS } from 'constants/countriesStates'
import {
  COST_STRATEGIES,
  CONTROL_OPTIONS,
  RULE_TYPES,
  IRegionOption,
  IControlOption,
  ICostStrategyOption,
  IRuleTypeOption,
} from '../types/costControlConfig'

export const costControlMessage =
  'More specific geographic rules override less specific rules. For example, regional rules override the baseline rules. Additionally, it is best practice to set bidding strategies equal to or higher than covering strategies.'

export const regionOptions: IRegionOption[] = [
  {
    label: 'Coastal',
    value: REGION_ABBREVIATIONS.C,
  },
  {
    label: 'South',
    value: REGION_ABBREVIATIONS.S,
  },
  {
    label: 'West',
    value: REGION_ABBREVIATIONS.W,
  },
  {
    label: 'Northeast',
    value: REGION_ABBREVIATIONS.N,
  },
  {
    label: 'Midwest',
    value: REGION_ABBREVIATIONS.MW,
  },
  {
    label: 'Southeast',
    value: REGION_ABBREVIATIONS.SE,
  },
]

export const controlOptions: IControlOption[] = [
  {
    label: 'Spot Quoting',
    value: CONTROL_OPTIONS.quoting,
  },
  {
    label: 'CM Target',
    value: CONTROL_OPTIONS.covering,
  },
  {
    label: 'SBR',
    value: CONTROL_OPTIONS.sbr,
  },
]

export const costStrategyOptions: ICostStrategyOption[] = [
  {
    label: 'TCM25',
    value: COST_STRATEGIES.TCM25,
  },
  {
    label: 'TCM40',
    value: COST_STRATEGIES.TCM40,
  },
  {
    label: 'TCM50',
    value: COST_STRATEGIES.TCM50,
  },
  {
    label: 'TCM65',
    value: COST_STRATEGIES.TCM65,
  },
  {
    label: 'TCM75',
    value: COST_STRATEGIES.TCM75,
  },
  {
    label: 'DAT',
    value: COST_STRATEGIES.DAT,
  },
]

export const ruleTypeOptions: IRuleTypeOption[] = [
  {
    label: 'Baseline',
    value: RULE_TYPES.baseline,
  },
  {
    label: 'Lane (PU + DEL)',
    value: RULE_TYPES.lane,
  },
  {
    label: 'Outbound (PU)',
    value: RULE_TYPES.outbound,
  },
]
